import type { HomeBreadCrumbs } from "~/composables/useBreadCrumbs"

export enum SUPPORTED_PAGES_ENUM {
    Home = "Home",
    Store = "Store",
    ShowProduct = "ShowProduct",
    Offers = "Offers",
    ContactUs = "ContactUs",
    FAQ = "FAQ",
    AboutUs = "AboutUs",
    Blog = "Blog",
    ShopCart = "ShopCart",
    ShopDetails = "ShopDetails",
    ShoppingCard = "ShoppingCard",
    Mayorista = "Mayorista",
    Orders = "Orders",
    Beneficiaries = "Beneficiaries",
    FinancialReceiver = "FinancialReceiver",
    Profile = "Profile",
    FavoritesProducts = "FavoritesProducts"
}

export type SUPPORTED_PAGES = keyof typeof SUPPORTED_PAGES_ENUM

export const SUPPORTED_BREAD_CRUMBS_VALUES: HomeBreadCrumbs[] = [
    {
        name: SUPPORTED_PAGES_ENUM.Home,
        breadCrumbs: [{ name: "Home", route: "/" }],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Store,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.store", route: "/store" },
            { name: "breadCrumbs.allCategories" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.AboutUs,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.aboutUs" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.ShowProduct,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.store", route: "/store" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.ShopCart,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.shopCart" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.ContactUs,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.contactUs" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.ShopDetails,
        breadCrumbs: [{ name: "breadCrumbs.home", route: "/" }],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Offers,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.offers", route: "/offers" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Blog,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.blog", route: "/blog" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.ShoppingCard,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.shopping_card", route: "/shopping_card" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Mayorista,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.mayorista", route: "/mayorista" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Orders,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.orders", route: "/profile/orders" },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Beneficiaries,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            {
                name: "breadCrumbs.beneficiaries",
                route: "/profile/beneficiaries",
            },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.FinancialReceiver,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            {
                name: "breadCrumbs.financial_receiver",
                route: "/profile/financial_receivers",
            },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.Profile,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            {
                name: "breadCrumbs.profile",
                route: "/profile",
            },
        ],
    },
    {
        name: SUPPORTED_PAGES_ENUM.FavoritesProducts,
        breadCrumbs: [
            { name: "breadCrumbs.home", route: "/" },
            { name: "breadCrumbs.favorites_products", route: "/profile/favorites" },
        ],
    },
]
